import styled from 'styled-components';

export const RadioButton = styled.div`
  cursor: pointer;
  > i {
    color: ${props => (props.checked ? '#00AB97' : '#455A64')};
  }
`;
